import React, { useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Title } from 'components/Title';

  import { InputNumber } from "primereact/inputnumber";
  import { Toast } from "primereact/toast";
export default function BulkupdatetempletePage() {
	
	const [pageReady, setPageReady] = useState(true);
  const API_BASE = process.env.REACT_APP_API_PATH;
  const [fromId, setFromId] = useState(null);
  const [toId, setToId] = useState(null);
  const [templateId, setTemplateId] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = React.useRef(null);
  const handleBulkUpdate = async () => {
      if (!fromId || !toId || !templateId) {
          toast.current.show({
              severity: "warn",
              summary: "Missing fields",
              detail: "Please fill in all fields before submitting.",
          });
          return;
      }
      setLoading(true);
      try {
          const response = await fetch(
          `${API_BASE}email/bulkupdate?fromId=${fromId}&toId=${toId}&newTemplateId=${templateId}`,
          {
              method: "POST",
              headers: { "Content-Type": "application/json" },
          }
          );
          if (response.ok) {
              const text = await response.text();
              toast.current.show({
                  severity: "success",
                  summary: "Success",
                  detail: text,
              });
              } else {
              const error = await response.text();
              toast.current.show({
                  severity: "error",
                  summary: "Error",
                  detail: error,
              });
          }
          } catch (error) {
          toast.current.show({
              severity: "error",
              summary: "Network Error",
              detail: error.message,
          });
          } finally {
          setLoading(false);
      }
  };
	return (
		<main id="BulkupdatetempletePage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="BulkUpdateTemplete"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div className="flex justify-center mt-6">
                        <Toast ref={toast} />
                        <Card title="Bulk Update Template ID" className="w-full md:w-6/12 p-4">
                        <div className="p-fluid grid">
                            <div className="col-12 md:col-4">
                                <label>From ID</label>
                                <InputNumber value={fromId} onValueChange={(e) => setFromId(e.value)} />
                            </div>
                            <div className="col-12 md:col-4">
                                <label>To ID</label>
                                <InputNumber value={toId} onValueChange={(e) => setToId(e.value)} />
                            </div>
                            <div className="col-12 md:col-4">
                                <label>Template ID</label>
                                <InputNumber value={templateId} onValueChange={(e) => setTemplateId(e.value)} />
                            </div>
                            <div className="col-12 mt-3 text-center">
                                <Button
                                label="Bulk Update"
                                icon="pi pi-send"
                                loading={loading}
                                onClick={handleBulkUpdate}
                                />
                            </div>
                        </div>
                        </Card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
